var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('DistributeIpMenu',{ref:"DistributeTableButton",attrs:{"refreshBtn":true,"deleteBtn":true,"exportTemplateBtn":true,"importBtn":true},on:{"notify":_vm.notify,"keywords":_vm.changeKeywords}})],1),_c('div',[_c('DistributeIpTable',{ref:"distributeTable"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }